export const CLOSE_MODAL = "CLOSE_MODAL";
export const OPEN_MODAL_AND_ASYNC_CALL = "OPEN_MODAL_AND_ASYNC_CALL";
export const WHEEL_PACKAGE_ASYNC_SUCCESS = "WHEEL_PACKAGE_ASYNC_SUCCESS";
export const WHEEL_PACKAGE_ASYNC_FAILED = "WHEEL_PACKAGE_ASYNC_FAILED";